/**
 * @module FindARole
 */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import BrowseRoles from './components/BrowseRoles';
import JobList from './components/JobList';
import JobSearchAssistance from './components/JobSearchAssistance';

/**
 * Represents the view for Find a Role page for Life.Church Careers.
 *
 * @param {object} props - The component props object.
 * @param {Array<Job>} props.jobs - Array of job data objects.
 * @param {string} props.jobTeam - Optional team name of a job, used for filtering to a specific team.
 * @param {Array<Team>} props.teams - Array of team data objects.
 *
 * @returns {React.ReactElement} The FindARole component.
 */
export default function FindARole({ jobs, jobTeam, teams }) {
  return (
    <div className="find-a-role container" data-testid="lc-find-a-role">
      <div className="content-section">
        <BrowseRoles jobTeam={jobTeam} teams={teams} />
        <JobList jobs={jobs} />
        <JobSearchAssistance jobsCount={jobs?.length} />
      </div>
    </div>
  );
}
